export default __webpack_public_path__ + "static/landing-video-9bfe92845a70dff1bac023b9c2252312.mp4";